var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.isStage || _setup.isSmoke
    ? _c("div", { staticClass: "core-line-stage text-h6 py-1 text-center" }, [
        _vm._v("\n  " + _vm._s(_setup.text) + "\n"),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }